export const ensureLeadingSlash = (pathPart: string): string => {
  return pathPart.startsWith('/') ? pathPart : `/${pathPart}`
}

export const addTrailingSlash = (url: string): string => {
  if (url.endsWith('/')) {
    return url
  }

  return `${url}/`
}

export const trimTrailingSlash = (path: string): string => {
  if (path === '/') {
    return path
  }

  return path.endsWith('/') ? path.slice(0, -1) : path
}
